export default "__VITE_ASSET__2946d6c1__"